export const updateCoreState = (state, payload) => {
  state[payload.state] = payload.data;
};
